import { OperationOutcomeError } from "@medplum/core";

/**
 * True when `error` likely indicates a stale `If-Match` / ETag (HTTP 412 / FHIR conflict), so a
 * single re-read and retry may succeed.
 */
export function isMedplumIfMatchConflictError(error: unknown): boolean {
  if (error instanceof OperationOutcomeError) {
    const issues = error.outcome?.issue ?? [];
    return issues.some((issue) => {
      if (issue.code === "conflict") return true;
      const text = `${issue.diagnostics ?? ""} ${issue.details?.text ?? ""}`.toLowerCase();
      return (
        text.includes("precondition") ||
        text.includes("if-match") ||
        text.includes("etag") ||
        (text.includes("version") && text.includes("mismatch"))
      );
    });
  }

  if (error instanceof Error) {
    const message = error.message.toLowerCase();
    return message.includes("412") || message.includes("precondition failed");
  }

  return false;
}
